<template>
    <div class="table-container">
        <!-- <el-form :inline="true" size="small" :model="dataForm" @keyup.enter.native="getDataList()"> -->
            <!-- <el-form-item label="组织编码:">
            <el-input size="small" v-model="dataForm.code" placeholder="组织编码" clearable></el-input>
            </el-form-item> -->
            <!-- <el-form-item label="组织名称:">
                <el-input size="small" v-model="dataForm.name" placeholder="组织名称" clearable></el-input>
            </el-form-item> -->
            <!-- <el-form-item> -->
                <!-- <el-button size="small" @click="getDataList()" icon="el-icon-search">
                    查询
                </el-button> -->
                <el-button size="small" type="primary" @click="addOrUpdateHandle()" icon="el-icon-plus">
                    新建根组织
                </el-button>
<!--            </el-form-item>-->
<!--        </el-form>-->
        <el-table :data="dataList"
        row-key="id"
        size="small"
        style="width: 100%;"
        :default-expand-all="true"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        :height="tableHeight"
        >
            <el-table-column
                    type="index"
                    width="50"
                    label="序号">
            </el-table-column>
            <el-table-column
                    prop="orgCode"
                    header-align="left"
                    align="left"
                    label="编码">
            </el-table-column>
            <el-table-column
                    prop="orgName"
                    header-align="left"
                    align="left"
                    label="名称">
            </el-table-column>
            <el-table-column
                    prop="orgType"
                    header-align="left"
                    align="left"
                    label="组织类型"
                    :formatter="formatOrgType"
                    >
            </el-table-column>
            <!--<el-table-column prop="tenantName" header-align="left" align="left" min-width="100" label="租户">-->
            <!--</el-table-column>-->
            <el-table-column header-align="left" align="left" min-width="130" label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="addChildHandle(null,scope.row.id,scope.row.orgName, scope.row.nodePath,scope.row.orgType)" icon="el-icon-circle-plus-outline">
                        新建附属组织
                    </el-button>
                    <el-button type="text" size="small" @click="updateHandle(scope.row)" icon="el-icon-edit">
                        修改
                    </el-button>
                    <el-button type="text" size="small" @click="deleteHandle(scope.row.id)" icon="el-icon-delete">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
        <add-or-update-child v-if="addOrUpdateVisibleChild" ref="addOrUpdateChild" @refreshDataList="getDataList"></add-or-update-child>
        <update v-if="updateVisible" ref="update" @refreshDataList="getDataList"></update>
    </div>
</template>

<script>
    import {fetchOrgForTenant, fetchOrgForMainBody, deleteOrg, getParentOrgType} from '@/controller/sys'
    import AddOrUpdate from './org-add-or-update'
    import AddOrUpdateChild from './org-add-or-update-child.vue';
    import Update from './org_update.vue'
    export default {
        name:'OrgIndex',
        data() {
            return {
                documentClientHeight: document.documentElement['clientHeight'] - 220,
                dataForm: {
                    code: '',
                    name: '',

                },
                dataList: [],
                tenantList: [],
                pageIndex: 1,
                pageSize: 100000,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                addOrUpdateVisible: false,
                addOrUpdateVisibleChild: false,
                updateVisible: false,
                parentOrgType: ''

            }
        },
        computed: {
            tableHeight: {
                get() {
                    return this.$store.state.common.documentClientHeight - 215
                }
            }

        },
        components: {
            Update,
            AddOrUpdate,
            AddOrUpdateChild

        },
        activated() {
            this.getDataList()
        },
        methods: {
            // 新增或编辑子节点
            addChildHandle(id, parentId, parentName, parentNodePath, orgType) {
                this.addOrUpdateVisibleChild = true
                this.$nextTick(() => {
                        this.$refs.addOrUpdateChild.init(null, parentId, parentName, parentNodePath, orgType)
                })
            },

              // 新增根目录
              addOrUpdateHandle(row) {
                this.addOrUpdateVisible = true
                this.$nextTick(() => {
                    console.log("jjjjj",this.$refs.addOrUpdate)
                    this.$refs.addOrUpdate.init(row?row.id: null, 0, null, null, null)
                })
            },

            //修改
            updateHandle(row) {

                //查找上一级的orgType
                getParentOrgType({
                    nodePath: row.nodePath
                }).then(res=>{
                    if(res && res.code == '00'){
                        this.parentOrgType = res.body
                    }
                    console.log("ggg555",this.parentOrgType )
                this.updateVisible = true
                this.$nextTick(() => {
                    this.$refs.update.init(row?row.id: null, 0, null, null, this.parentOrgType)
                })
                })

            },






            // 获取数据列表
            getDataList() {
                this.dataListLoading = true
                if(this.$store.state.user.userInfo.typeId === 2){
                    fetchOrgForTenant(
                        {
                            'orgCode': this.dataForm.code,
                            'orgName': this.dataForm.name
                        }
                    ).then(data => {
                        if (data && data.code === '00') {
                            this.dataList = data.body
                            this.totalPage = data.body.total
                        } else {
                            this.dataList = []
                            this.totalPage = 0
                        }
                        this.dataListLoading = false
                    })
                } else {
                    // TODO 查询条件
                    fetchOrgForMainBody(
                        {}, sessionStorage.getItem('mainBodyId')
                    ).then(data => {
                        if (data && data.code === '00') {
                            this.dataList = data.body
                            this.totalPage = data.body.total
                        } else {
                            this.dataList = []
                            this.totalPage = 0
                        }
                        this.dataListLoading = false
                    })
                }
            },
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val
                this.pageIndex = 1
                this.getDataList()
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val
                this.getDataList()
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val
            },

            // 删除
            deleteHandle(id) {
                this.$confirm(`确定进行删除操作?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteOrg(
                        {}, id
                    ).then(data => {
                        if (data && data.code === '00') {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    this.getDataList()
                                }
                            })
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
                })
            },

            //转换组织类型
            formatOrgType(row, column, value, index){
                console.log("测试打包的代码为什么没有推上去")
                const typeMap = {
                    'ROOT': '总部',
                    'DIV': '事业部',
                    'COM': '子公司',
                    'PUR': '采购组织',
                    'WORK': '工厂',
                    'DEP': '部门',
                    'STUDIO':'科室',
                    'OTHER': '其他'
                };
                return typeMap[value] || value;
            }
        }
    }
</script>

<style>
    .table-container {
        /* height: 680px; */
        /* overflow-y: auto; */
    }
</style>
